/**
 * Google Places Configuration
 * Place ID: ChIJy_493HvDLWcRdiQR-87vf-k
 */

export const GOOGLE_PLACE_CONFIG = {
  placeId: 'ChIJy_493HvDLWcRdiQR-87vf-k',
  
  // Direct links using Place ID
  writeReviewUrl: 'https://search.google.com/local/writereview?placeid=ChIJy_493HvDLWcRdiQR-87vf-k',
  viewReviewsUrl: 'https://search.google.com/local/reviews?placeid=ChIJy_493HvDLWcRdiQR-87vf-k',
  
  // For Google Maps embed
  mapsEmbedUrl: 'https://www.google.com/maps/embed/v1/place?q=place_id:ChIJy_493HvDLWcRdiQR-87vf-k',
  
  // Business info (auto-updated from API)
  businessName: 'Go Turkey Transfer',
  rating: 5.0,
  totalReviews: 12, // Will be updated dynamically from API
};

// Schema.org structured data for Google
// aggregateRating removed - only factual data should be in structured data
// Re-add when dynamic review count is available from Google Places API
export const getGoogleReviewSchema = () => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": GOOGLE_PLACE_CONFIG.businessName,
  "@id": `https://goturkeytransfer.com/#business`
});

export default GOOGLE_PLACE_CONFIG;
